(() => {
  'use strict';
  if (window.CZSeasonalCartOffer) return;
  const settingsNode = document.getElementById('cz-seasonal-cart-settings');
  const template = document.getElementById('cz-seasonal-cart-template');
  if (!settingsNode || !template) return;
  let settings;
  try { settings = JSON.parse(settingsNode.textContent); } catch (_) { return; }
  if (settings.enabled === false) return;
  const italian = String(settings.locale || document.documentElement.lang).startsWith('it');
  const defaults = italian ? {
    eyebrow: 'Seasonal Box', title_top: 'Aggiungi pantalone e occhiali.', title_bottom: 'Aggiungi un top e occhiali.',
    extra: 'Con {amount} in più', recurring: 'Abbonamento · {amount} a stagione', cta: 'Crea il mio box',
    fine_print: 'Spedizione gratuita. Imposte calcolate al checkout.',
    vat_fine_print: 'Il tuo capo con IVA stimata: {amount}. Spedizione del box gratuita.',
    taxes_included: 'Imposte incluse.', free_shipping: 'Spedizione gratuita.'
  } : {
    eyebrow: 'Seasonal Box', title_top: 'Add pants + sunglasses.', title_bottom: 'Add a top + sunglasses.',
    extra: 'For {amount} more', recurring: 'Subscription · {amount} / season', cta: 'Build my box',
    fine_print: 'Free shipping. Taxes calculated at checkout.',
    vat_fine_print: 'Your item incl. estimated VAT: {amount}. Free shipping on the box.',
    taxes_included: 'Taxes included.', free_shipping: 'Free shipping.'
  };
  const decodeLabel = value => {
    const decoder = document.createElement('textarea');
    decoder.innerHTML = value.replace(/</g, '&lt;');
    return decoder.value;
  };
  const labels = Object.fromEntries(Object.entries(defaults).map(([key, fallback]) => {
    const value = settings.labels && settings.labels[key];
    return [key, typeof value === 'string' && value.trim() && !/translation missing|missing translation|\[missing|sections\.cz[-_]seasonal[-_]cart/i.test(value) ? decodeLabel(value) : fallback];
  }));
  const southern = new Set('AU NZ ZA AR CL UY PY BO PE BR NA BW ZW MZ MG MU RE LS SZ ZM MW TZ AO NC PF FJ WS TO PG SB VU TL ID'.split(' '));
  const opposite = { spring: 'autumn', summer: 'winter', autumn: 'spring', winter: 'summer' };
  const starts = { spring: '03-01', summer: '06-01', autumn: '09-01', winter: '12-01' };
  const rootUrl = new URL(settings.rootUrl || '/', location.origin);
  if (!rootUrl.pathname.endsWith('/')) rootUrl.pathname += '/';
  const boxUrl = new URL(settings.boxUrl, location.origin);
  if (rootUrl.pathname !== '/' && boxUrl.pathname.startsWith('/products/')) boxUrl.pathname = rootUrl.pathname + boxUrl.pathname.slice(1);
  if (rootUrl.origin !== location.origin || boxUrl.origin !== location.origin) return;

  function activeSeason(config, now = new Date()) {
    if (config.seasonOverride && config.seasonOverride !== 'auto') return config.seasonOverride;
    const parts = new Intl.DateTimeFormat('en-US', { timeZone: config.timeZone || 'Europe/Rome', month: '2-digit', day: '2-digit' }).formatToParts(now);
    const today = Number(parts.find(p => p.type === 'month').value) * 100 + Number(parts.find(p => p.type === 'day').value);
    const schedule = Object.entries(starts).map(([season, fallback]) => {
      const value = config.starts && config.starts[season] || fallback;
      if (!/^\d{2}-\d{2}$/.test(value)) throw new Error('Invalid season');
      const [month, day] = value.split('-').map(Number);
      const date = new Date(Date.UTC(2024, month - 1, day));
      if (month < 1 || month > 12 || day < 1 || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) throw new Error('Invalid season');
      return { season, value: month * 100 + day };
    }).sort((a, b) => a.value - b.value);
    if (new Set(schedule.map(s => s.value)).size !== 4) throw new Error('Duplicate season');
    let current = schedule[schedule.length - 1].season;
    for (const entry of schedule) if (entry.value <= today) current = entry.season;
    return southern.has(String(config.country).toUpperCase()) ? opposite[current] : current;
  }
  function categoryFor(item) {
    const title = String(item.product_title || item.title || '');
    if (/\b(hoodie|hoodies|sweatshirt|sweatshirts|felpa|felpe)\b/i.test(title)) return 'tops';
    if (/\b(jeans|denim)\b/i.test(title) && !/\b(jacket|shirt|shorts|skirt|dress|giacca|camicia|gonna)\b/i.test(title)) return 'bottoms';
    return null;
  }
  function singleItem(cart) {
    if (!cart || cart.item_count !== 1 || !Array.isArray(cart.items) || cart.items.length !== 1) return null;
    const item = cart.items[0];
    if (item.quantity !== 1 || item.selling_plan_allocation || !item.key || !categoryFor(item)) return null;
    return item;
  }
  function readCatalog(html) {
    const document = new DOMParser().parseFromString(html, 'text/html');
    const node = document.querySelector('[data-cz-config]');
    if (!node) throw new Error('Box configuration unavailable');
    const config = JSON.parse(node.textContent);
    const products = Array.from(document.querySelectorAll('[data-cz-product-data]'), node => JSON.parse(node.textContent));
    if (!config.currency || !Array.isArray(config.variants) || !products.length) throw new Error('Box unavailable');
    return { config, products };
  }
  function offerFor(cart, catalog) {
    const item = singleItem(cart);
    if (!item) return null;
    const category = categoryFor(item);
    const product = catalog.products.find(p => p.category === category && p.handle === item.handle && Array.isArray(p.variants) && p.variants.some(v => String(v.id) === String(item.variant_id || item.id)));
    if (!product || cart.currency !== catalog.config.currency) return null;
    if (settings.country && catalog.config.country !== settings.country) return null;
    const season = activeSeason(catalog.config);
    const variant = catalog.config.variants.find(v => v.season === season);
    if (!variant || !variant.available || !variant.planId || !Number.isFinite(variant.subscriptionPriceCents) || variant.subscriptionPriceCents <= 0) return null;
    const baseline = cart.total_price;
    if (!Number.isFinite(baseline) || baseline < 0) return null;
    const taxesIncluded = cart.taxes_included === true || catalog.config.taxesIncluded === true;
    const customerTaxExempt = catalog.config.customerTaxExempt === true;
    const configuredRate = Number.isFinite(catalog.config.vatRateBps) ? catalog.config.vatRateBps : 0;
    const rate = !taxesIncluded && !customerTaxExempt ? Math.max(0, configuredRate) : 0;
    const boxDisplayPrice = variant.subscriptionPriceCents + (variant.taxable === false ? 0 : Math.round(variant.subscriptionPriceCents * rate / 10000));
    const baselineDisplayPrice = baseline + (item.taxable === false ? 0 : Math.round(baseline * rate / 10000));
    const delta = boxDisplayPrice - baselineDisplayPrice;
    if (delta <= 0) return null;
    return { item, category, product, variant, delta, boxDisplayPrice, baselineDisplayPrice, vatEstimated: rate > 0 && (variant.taxable !== false || item.taxable !== false), taxesIncluded, customerTaxExempt, vatLabels: catalog.config.labels || {}, currency: cart.currency, season };
  }
  function money(amount, currency) {
    return new Intl.NumberFormat(settings.locale || document.documentElement.lang || 'en', {
      style: 'currency', currency, minimumFractionDigits: amount % 100 === 0 ? 0 : undefined,
      maximumFractionDigits: 2
    }).format(amount / 100);
  }
  function finePrintFor(offer) {
    const translated = (key, fallback) => {
      const value = offer.vatLabels[key];
      return typeof value === 'string' && value.trim() && !/translation missing|missing translation|\[missing|sections\.cz[-_]seasonal[-_]box/i.test(value) ? decodeLabel(value) : fallback;
    };
    const freeShipping = translated('free_shipping', labels.free_shipping);
    if (offer.vatEstimated) return translated('vat_offer_note', labels.vat_fine_print).replace('{amount}', money(offer.baselineDisplayPrice, offer.currency));
    if (offer.customerTaxExempt || offer.variant.taxable === false && offer.item.taxable === false) return freeShipping;
    if (offer.taxesIncluded) return `${freeShipping} ${translated('taxes_included', labels.taxes_included)}`;
    return labels.fine_print;
  }
  function visible(node) { return node && node.getClientRects().length > 0; }
  function hosts() {
    const result = Array.from(document.querySelectorAll('.cart-page__items')).filter(visible);
    document.querySelectorAll('cart-drawer-component dialog[open], cart-drawer dialog[open]').forEach(drawer => {
      const host = drawer.querySelector('.cart-drawer__items, .cart-items__wrapper');
      if (visible(host)) result.push(host);
    });
    return [...new Set(result)];
  }
  function hide() {
    document.querySelectorAll('.cz-cart-offer').forEach(node => { node.hidden = true; });
  }
  function put(node, key, value) {
    const target = node.querySelector(`[data-cz-cart-${key}]`);
    if (target) target.textContent = value;
  }
  let catalogCache = null;
  let catalogPromise = null;
  let cachedAt = 0;
  const cacheTTL = 90000;
  const cacheStorageKey = 'cz-seasonal-cart-catalog-v2';
  const cacheContext = JSON.stringify([location.origin, rootUrl.href, boxUrl.href, settings.sectionId,
    settings.country, settings.currency, settings.locale, settings.customerId,
    settings.customerTaxExempt, settings.taxesIncluded]);
  const persistentCacheEnabled = typeof settings.customerId === 'string' && typeof settings.customerTaxExempt === 'boolean' && typeof settings.taxesIncluded === 'boolean';
  let revision = 0;
  let timer;
  let lastOffer = null;
  let initialCart = hosts().length && settings.initialCart ? settings.initialCart : null;
  const impressions = new Set();
  function validCatalog(value) {
    return value && value.config && value.config.currency === settings.currency &&
      value.config.country === settings.country && Array.isArray(value.config.variants) && Array.isArray(value.products) && value.products.length > 0 &&
      (!persistentCacheEnabled || value.config.customerTaxExempt === settings.customerTaxExempt && value.config.taxesIncluded === settings.taxesIncluded);
  }
  function restoreCatalog() {
    if (!persistentCacheEnabled) return;
    try {
      const cached = JSON.parse(sessionStorage.getItem(cacheStorageKey));
      const age = Date.now() - cached?.at;
      if (cached?.context !== cacheContext || !Number.isFinite(age) || age < 0 || age >= cacheTTL || !validCatalog(cached.catalog)) return;
      catalogCache = cached.catalog;
      cachedAt = cached.at;
    } catch (_) {}
  }
  function saveCatalog() {
    if (!persistentCacheEnabled || !validCatalog(catalogCache)) return;
    try { sessionStorage.setItem(cacheStorageKey, JSON.stringify({ context: cacheContext, at: cachedAt, catalog: catalogCache })); } catch (_) {}
  }
  async function fetchText(url) {
    const response = await fetch(url, { headers: { Accept: 'text/html' }, credentials: 'same-origin', signal: AbortSignal.timeout(12000) });
    if (!response.ok) throw new Error('Box unavailable');
    return response.text();
  }
  async function catalog() {
    if (catalogCache && Date.now() - cachedAt < cacheTTL) return catalogCache;
    restoreCatalog();
    if (catalogCache && Date.now() - cachedAt < cacheTTL) return catalogCache;
    if (catalogPromise) return catalogPromise;
    catalogPromise = (async () => {
      let result;
      if (settings.sectionId) {
        try {
          const url = new URL(boxUrl);
          url.searchParams.set('section_id', settings.sectionId);
          result = readCatalog(await fetchText(url));
        } catch (_) { result = null; }
      }
      if (!result) result = readCatalog(await fetchText(boxUrl));
      catalogCache = result;
      cachedAt = Date.now();
      saveCatalog();
      return result;
    })();
    try { return await catalogPromise; } finally { catalogPromise = null; }
  }
  function emit(name, offer) {
    document.dispatchEvent(new CustomEvent(name, { detail: {
      source: 'cart', productHandle: offer.item.handle, variantId: String(offer.item.variant_id || offer.item.id),
      category: offer.category, currency: offer.currency, difference: offer.delta, boxPrice: offer.variant.subscriptionPriceCents, displayBoxPrice: offer.boxDisplayPrice
    } }));
  }
  function mount(offer) {
    for (const host of hosts()) {
      let card = Array.from(host.children).find(child => child.classList.contains('cz-cart-offer'));
      if (!card) {
        card = template.content.firstElementChild.cloneNode(true);
        host.appendChild(card);
      }
      put(card, 'eyebrow', labels.eyebrow);
      put(card, 'title', labels[offer.category === 'tops' ? 'title_top' : 'title_bottom']);
      put(card, 'extra', labels.extra.replace('{amount}', money(offer.delta, offer.currency)));
      put(card, 'recurring', labels.recurring.replace('{amount}', money(offer.boxDisplayPrice, offer.currency)));
      put(card, 'fine-print', finePrintFor(offer));
      const link = card.querySelector('[data-cz-cart-link]');
      const text = link.querySelector('[data-cz-cart-cta], [data-cz-cart-link-text]');
      if (text) text.textContent = labels.cta;
      else link.textContent = labels.cta + ' →';
      const url = new URL(boxUrl);
      url.searchParams.set('cz_upgrade', '1');
      url.searchParams.set('cz_item', offer.item.key);
      url.searchParams.set('cz_variant', String(offer.item.variant_id || offer.item.id));
      url.searchParams.set('cz_category', offer.category);
      url.searchParams.set('cz_source', 'cart');
      link.href = url.href;
      link.onclick = () => emit('cz:seasonal-offer-click', offer);
      const image = card.querySelector('[data-cz-cart-image]');
      const source = offer.item.featured_image && offer.item.featured_image.url || offer.item.image || offer.product.image;
      image.hidden = !source;
      if (source) {
        const imageUrl = new URL(source, location.origin);
        if (imageUrl.protocol === 'https:' || imageUrl.protocol === 'http:') {
          imageUrl.searchParams.set('width', '180');
          image.src = imageUrl.href;
          image.alt = offer.item.product_title || offer.product.title;
        } else image.hidden = true;
      }
      card.hidden = false;
    }
    if (hosts().length) {
      const fingerprint = [offer.item.key, offer.currency, offer.delta, offer.season].join('|');
      if (!impressions.has(fingerprint)) { impressions.add(fingerprint); emit('cz:seasonal-offer-view', offer); }
    }
  }
  async function refresh() {
    const current = ++revision;
    hide();
    lastOffer = null;
    if (!hosts().length) return;
    try {
      let cart = initialCart;
      initialCart = null;
      if (cart && !singleItem(cart)) return;
      const dataPromise = catalog().catch(() => null);
      if (!cart) {
        const response = await fetch(new URL('cart.js', rootUrl), { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin', signal: AbortSignal.timeout(10000) });
        if (!response.ok) return;
        cart = await response.json();
      }
      if (current !== revision || !singleItem(cart)) return;
      const data = await dataPromise;
      if (current !== revision || !data) return;
      lastOffer = offerFor(cart, data);
      if (lastOffer) mount(lastOffer);
    } catch (_) { if (current === revision) hide(); }
  }
  function schedule(delay = 50, invalidateCart = true) {
    if (invalidateCart) initialCart = null;
    ++revision;
    hide();
    lastOffer = null;
    clearTimeout(timer);
    timer = setTimeout(refresh, delay);
  }
  ['cart:update', 'discount:update', 'shopify:section:load'].forEach(name => document.addEventListener(name, () => schedule()));
  document.addEventListener('quantity-selector:update', () => schedule(700));
  window.addEventListener('pageshow', event => { if (event.persisted) schedule(0); });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') schedule(); });
  const observer = new MutationObserver(records => {
    let changed = false;
    for (const record of records) {
      const target = record.target instanceof Element ? record.target : record.target.parentElement;
      if (target && target.closest('.cz-cart-offer')) continue;
      if (record.type === 'attributes' && target.matches('dialog')) { changed = true; break; }
      const nodes = [...record.addedNodes, ...record.removedNodes].filter(node => node instanceof Element && !node.matches('.cz-cart-offer'));
      if (nodes.some(node => node.matches('cart-items-component, .cart-page, .cart-page__items, .cart-items__wrapper') || node.querySelector('cart-items-component, .cart-page__items'))) { changed = true; break; }
      if (target && target.closest('cart-items-component, .cart-page__items, cart-drawer-component') && nodes.length) { changed = true; break; }
    }
    if (changed) schedule();
    else if (lastOffer && hosts().some(host => !Array.from(host.children).some(child => child.classList.contains('cz-cart-offer')))) mount(lastOffer);
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
  const intentSelector = 'form[action*="/cart/add"], product-form-component, add-to-cart-component, [data-add-to-cart], [ref="cartDrawerButton"], cart-icon, a[href*="/cart"]';
  let warmTimer;
  function warmOnIntent(event) {
    if (!(event.target instanceof Element) || !event.target.closest(intentSelector)) return;
    if (event.type === 'pointerover' && event.relatedTarget instanceof Element && event.target.closest(intentSelector).contains(event.relatedTarget)) return;
    clearTimeout(warmTimer);
    warmTimer = setTimeout(() => { catalog().catch(() => {}); }, event.type === 'pointerover' ? 100 : 0);
  }
  ['pointerover', 'focusin', 'pointerdown', 'submit'].forEach(name => document.addEventListener(name, warmOnIntent, { capture: true, passive: true }));
  window.CZSeasonalCartOffer = { refresh: () => schedule(0), activeSeason, categoryFor, offerFor };
  restoreCatalog();
  schedule(0, false);
})();

